module.exports = __webpack_public_path__ + "img/michel_bastide_rounded_gray.6dc71bca.jpg";